import {reactive} from 'vue'
import {IUserData} from '@/types/types'
import {getUserInfo} from '@/utils/util'
import {scopeSearchApi} from '@/api/common'
// import {loginApi} from '@/api/common'
// import {ILoginFrom} from '@/types/types'
import { ElMessage } from 'element-plus'
import {useRouter} from 'vue-router'
import {useStore} from "vuex"

// import{useStore} from "vuex"


export default function useWrapper(){
  const rawData = reactive({
    searchInfo:null
  })


  function scopeSearch(){
    const userInfo = getUserInfo()
    if(userInfo){
      const data = {Name:userInfo.Name,CardNumber:userInfo.CardNumber}
      scopeSearchApi(data).then((res:any)=>{
        if(res && res.state ===0){
          rawData.searchInfo = res.content
        }
      })
    }
  }


  return {rawData,scopeSearch}
}
